(() => {
  // Wrap time so it loops perfectly
  const wrap = (t, d) => {
    t = (t % d + d) % d;
    return t >= d - 0.002 ? 0 : t;
  };

  document.querySelectorAll('.diamond-scrub').forEach(wrapEl => {
    const video = wrapEl.querySelector('video');
    const src = wrapEl.dataset.src;
    const SENS = parseFloat(wrapEl.dataset.sensitivity) || 200;

    // Load video
    video.src = src;
    video.muted = true;
    video.playsInline = true;
    video.loop = true;

    video.addEventListener('canplay', () => {
      wrapEl.classList.add('is-loaded');

      try { video.currentTime = 0.0001; } catch(e) {}
      if (video.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.play().catch(() => {});
      }
    }, { once: true });

    // Drag variables
    let dragging = false;
    let startX = 0;
    let startT = 0;
    let raf = null;

    const down = x => {
      if (!video.duration) return;
      dragging = true;
      startX = x;
      startT = video.currentTime;
      video.pause();
    };

    const move = x => {
      if (!dragging || !video.duration) return;

      const dx = x - startX;
      const raw = startT + (dx / SENS) * video.duration;
      const t = wrap(raw, video.duration);

      if (!raf) {
        raf = requestAnimationFrame(() => {
          video.currentTime = t;
          raf = null;
        });
      }
    };

    const up = () => {
      if (!dragging) return;
      dragging = false;

      if (video.autoplay &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.play().catch(() => {});
      }
    };

    // Mouse
    wrapEl.addEventListener('mousedown', e => down(e.clientX));
    window.addEventListener('mousemove', e => move(e.clientX));
    window.addEventListener('mouseup', up);

    // Touch
    wrapEl.addEventListener('touchstart', e => down(e.touches[0].clientX), { passive: true });
    wrapEl.addEventListener('touchmove', e => move(e.touches[0].clientX), { passive: true });
    wrapEl.addEventListener('touchend', up);

    // Pause when offscreen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        if (!entry) return;

        if (entry.isIntersecting && !dragging && video.autoplay &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play().catch(() => {});
        } else if (!dragging) {
          video.pause();
        }
      }, { threshold: [0.25, 0.5] });

      io.observe(wrapEl);
    }

    wrapEl.addEventListener('dragstart', e => e.preventDefault());
  });
})();
